import { createUrl, getECommerceDomainByEnv, sendRequest } from 'utils/utils'
import Infra from 'mobx/Infra'

const getNutrientsInformation = async (nutrientId: string) => {
	const res = await sendRequest(false, createUrl(getECommerceDomainByEnv(), `/v1/tenants/${Infra.appParams.c}/menu/nutrients/${nutrientId}`), 'get')
	return res?.data
}

export default { getNutrientsInformation }
